import EmptyState from '@/components/base/EmptyState';
import SpecialSection from '@/pages/special/components/SpecialSection';
import { specials } from '@/mocks/specials';
import { getMoviesByIds } from '@/lib/movies';
import { useSeo } from '@/hooks/useSeo';

export default function Special() {
  useSeo({
    title: '影视专题 - 麻豆传媒视频',
    description: '麻豆传媒视频影视专题页，汇集编辑精心策划的主题片单，涵盖新剧精选、科幻视界、治愈动漫与悬疑推理等专题内容。',
    keywords: '影视专题,主题片单,编辑推荐,影视合集,麻豆传媒视频',
  });

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="w-full">
      <div className="border-b border-background-200 bg-primary-900">
        <div className="mx-auto w-full px-4 md:px-8 py-10 md:py-14">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1 text-xs text-accent-300">
            <i className="ri-magic-line"></i>
            编辑策划专题
          </span>
          <h1 className="mt-4 font-heading text-2xl font-black text-background-50 md:text-4xl">影视专题</h1>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-background-200 md:text-base">
            我们从海量影视作品中，按主题、类型与情绪为你梳理成一份份精选片单。不必纠结看什么，跟着专题走，总能遇到惊喜。
          </p>

          <div className="mt-6 flex flex-wrap gap-2">
            {specials.map((s) => (
              <a
                key={s.id}
                href={`#${s.id}`}
                className="flex items-center gap-2 rounded-full border border-background-100/25 px-4 py-1.5 text-sm text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300 whitespace-nowrap"
              >
                <i className="ri-price-tag-3-line text-xs"></i>
                {s.title}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="mx-auto w-full px-4 md:px-8 py-10 md:py-14">
        {specials.length === 0 ? (
          <EmptyState
            icon="ri-article-line"
            title="暂时没有专题内容"
            description="专题正在策划更新中，你可以刷新页面，或先前往影视分类浏览更多内容。"
            actionLabel="刷新页面"
            onAction={handleRetry}
          />
        ) : (
          <div className="flex flex-col gap-14 md:gap-20">
            {specials.map((special) => (
              <SpecialSection key={special.id} special={special} list={getMoviesByIds(special.movieIds)} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}